if (!customElements.get("nmn-faq-accordion")) {
  customElements.define(
    "nmn-faq-accordion",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        if (!window.Shopify?.designMode) return;

        document.addEventListener("shopify:block:select", (event) => {
          if (!this.contains(event.target)) return;
          const question = event.target.closest("details");
          if (question) question.open = true;
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
